import React from 'react';
import { Route } from 'react-router-dom';
import { connectedRouterRedirect } from 'redux-auth-wrapper/history4/redirect';
import locationHelperBuilder from 'redux-auth-wrapper/history4/locationHelper';
import connectedAuthWrapper from 'redux-auth-wrapper/connectedAuthWrapper';
import { createBrowserHistory } from 'history';
import LoadingSpinner from '@components/LoadingSpinner';
import EmailVerification from '@containers/EmailVerification';
import { LOGIN, DASHBOARD } from '@config/routes';
// import { get } from 'lodash';

const locationHelper = locationHelperBuilder({});
const history = createBrowserHistory();

const AUTHED_REDIRECT = 'AUTHED_REDIRECT';
const UNAUTHED_REDIRECT = 'UNAUTHED_REDIRECT';

export const visibleOnlyAdmin = connectedAuthWrapper({
    FailureComponent: EmailVerification,
    authenticatedSelector: (state) => {
        return state.firebase.profile !== null && !state.firebase.profile.emailVerified;
    },
    wrapperDisplayName: 'VisibleOnlyAdmin',
});

// export const UserHasPermission = (permission) =>
//     UserAuthWrapper({
//         wrapperDisplayName: 'UserHasPermission',
//         LoadingComponent: <CircularProgress />,
//         allowRedirectBack: false,
//         failureRedirectPath: '/dashboard',
//         authenticatedSelector: ({ firebase: { profile, auth } }) => ({ auth, profile }),
//         authenticatingSelector: ({ firebase: { profile, auth, isInitializing } }) =>
//             auth === undefined || profile === undefined || isInitializing === true,
//         predicate: (auth) => get(auth, `profile.role.${permission}`, false),
//         redirectAction: (newLoc) => (dispatch) => {
//             history.replace(newLoc);
//             dispatch({
//                 type: UNAUTHED_REDIRECT,
//                 message: 'You dont have permission to view this page. Please upgrade',
//             });
//         },
//     });

// export const UserHasPermission = connectedRouterRedirect({
//     redirectPath: SOURCING_AGENTS_DASHBOARD,
//     AuthenticatingComponent: LoadingSpinner,
//     wrapperDisplayName: 'UserHasPermission',
//     // Want to redirect the user when they are done loading and authenticated
//     authenticatedSelector: ({ firebase: { profile } }) => profile.role === 'agent',
//     authenticatingSelector: ({ firebase: { profile, auth, isInitializing } }) =>
//         auth === undefined || profile === undefined || isInitializing === true,
//     redirectAction: (newLoc) => (dispatch) => {
//         // Use push, replace, and go to navigate around.
//         history.push(newLoc);
//         dispatch({
//             type: AGENTS_ONLY_REDIRECT,
//             payload: { message: 'User is not Authorized to view.' },
//         });
//     },
// });

// const NotAnAgent = () => {
//     render(<Typography>Not Authorized</Typography>);
// };

export const agentOrElse = (Component, FailureComponent) =>
    connectedAuthWrapper({
        authenticatedSelector: ({ firebase: { profile } }) => profile.role === 'agent',
        wrapperDisplayName: 'AdminOrElse',
        FailureComponent,
    })(Component);

export const UserHasPermission = connectedAuthWrapper({
    authenticatedSelector: ({ firebase: { profile } }) => profile.role === 'agent',
    authenticatingSelector: ({ firebase: { auth, isInitializing } }) =>
        !auth.isLoaded || isInitializing,
    FailureComponent: EmailVerification,
    wrapperDisplayName: 'UserHasPermission',
});

export const UserIsAuthenticated = connectedRouterRedirect({
    redirectPath: LOGIN,
    AuthenticatingComponent: LoadingSpinner,
    wrapperDisplayName: 'UserIsAuthenticated',
    // Want to redirect the user when they are done loading and authenticated
    authenticatedSelector: ({ firebase: { auth } }) => !auth.isEmpty && !!auth.uid,
    authenticatingSelector: ({ firebase: { auth, isInitializing } }) =>
        !auth.isLoaded || isInitializing,
    redirectAction: (newLoc) => (dispatch) => {
        // Use push, replace, and go to navigate around.
        history.push(newLoc);
        dispatch({
            type: AUTHED_REDIRECT,
            payload: { message: 'User is already authenticated.' },
        });
    },
});

export const UserIsNotAuthenticated = connectedRouterRedirect({
    AuthenticatingComponent: LoadingSpinner,
    wrapperDisplayName: 'UserIsNotAuthenticated',
    allowRedirectBack: false,
    // Want to redirect the user when they are done loading and authenticated
    authenticatedSelector: ({ firebase: { auth } }) => auth.isEmpty,
    authenticatingSelector: ({ firebase: { auth, isInitializing } }) =>
        !auth.isLoaded || isInitializing,
    redirectPath: (state, ownProps) => {
        // console.log(state);
        // console.log(ownProps);
        return locationHelper.getRedirectQueryParam(ownProps) || DASHBOARD;
    },
    redirectAction: (newLoc) => (dispatch) => {
        // Use push, replace, and go to navigate around.
        history.push(newLoc);
        dispatch({
            type: UNAUTHED_REDIRECT,
            payload: { message: 'User is not authenticated.' },
        });
    },
});
export const UserIsNotAdmin = connectedRouterRedirect({
    AuthenticatingComponent: LoadingSpinner,
    wrapperDisplayName: 'UserIsNotAdmin',
    allowRedirectBack: false,
    // Want to redirect the user when they are done loading and authenticated
    authenticatedSelector: ({ firebase: { auth } }) => auth.isEmpty || auth.role !== 'admin',
    authenticatingSelector: ({ firebase: { auth, isInitializing } }) =>
        !auth.isLoaded || isInitializing,
    redirectPath: (state, ownProps) => {
        return locationHelper.getRedirectQueryParam(ownProps) || LOGIN;
    },
    redirectAction: (newLoc) => (dispatch) => {
        // Use push, replace, and go to navigate around.
        history.push(newLoc);
        dispatch({
            type: UNAUTHED_REDIRECT,
            payload: { message: 'User is not authenticated.' },
        });
    },
});

export function renderChildren(routes, match, parentProps) {
    return routes.map((route) => (
        <Route
            key={`${match.url}-${route.path}`}
            path={`${match.url}/${route.path}`}
            render={(props) => <route.component {...parentProps} {...props} />}
        />
    ));
}
